import {env as envs} from '../env'
import '../graft/index'
export const goToLogin = function(host, env) {
    window.graft.app({
        functionName: "login",
        webFun: e => {
            let localhost = `http://${env}${host}.modian${host === 'm' && !env ? '' : 'inc'}.com/u/login?`
            let wxhost = "/mainPages/login/login?"
            let qqhost = "/ucenter/login/index"
            let address = encodeURIComponent(location.href)
            if (envs.isWxApp()) {
                wxhost = "/pages" + wxhost
                wx.miniProgram.navigateTo({
                    url: wxhost + "&redirect_url=" + address,
                })
            } else if (sessionStorage.getItem("miniProgram") == "qq") {
                qqhost = "/pages" + qqhost
                qq.miniProgram.navigateTo({
                    url: qqhost + "&redirect_url=" + address,
                })
            } else {
                location.href = localhost + "&redirect_url=" + address
            }
        }
    })
}
